import React from 'react';
import { Link } from 'react-router-dom';

const Home = () => {
  return (
    <div className="page-wrapper">
      <section className="hero-section-business">
        <div className="hero-content-business">
          <h1 className="hero-title-business">
            ArcaCapitalis
          </h1>
          <p className="hero-subtitle">
            Strategic Business Building for Entrepreneurs and Growing Companies
          </p>
          <div className="hero-description">
            <p>
              ArcaCapitalis helps entrepreneurs and businesses build strong foundations through 
              strategic research, operational structuring, and business consulting. We focus on 
              sustainable growth and structured development.
            </p>
            <p>
              Our approach emphasizes building first, scaling last. We help you develop business 
              strategies, conduct research, structure operations, and prepare for sustainable growth.
            </p>
            <p className="hero-pricing">
              Professional consulting engagements start at $750. Consultation required prior to engagement.
            </p>
          </div>
          <div className="hero-cta">
            <Link to="/about" className="btn-primary">
              Learn More
            </Link>
            <Link to="/contact" className="btn-secondary">
              Contact Us
            </Link>
          </div>
        </div>
      </section>

      <section className="mission-section">
        <div className="mission-container">
          <h2 className="mission-title">Mission Statement</h2>
          <div className="mission-content">
            <p className="mission-paragraph">
              ArcaCapitalis exists to help entrepreneurs and businesses build structure-first systems that 
              prioritize stability, strategic planning, and long-term sustainability.
            </p>
            <p className="mission-paragraph">
              We help businesses build strong operational foundations before pursuing 
              growth or expansion. Our approach emphasizes disciplined planning, 
              proper structural development, and data-driven decision making.
            </p>
            <p className="mission-paragraph">
              We believe business success is not created through speed or shortcuts, but through 
              systems engineered to withstand challenges and time.
            </p>
            <p className="mission-tagline">
              Build First. Scale Last.
            </p>
          </div>
        </div>
      </section>

      <section className="philosophy-section">
        <div className="philosophy-container">
          <h2 className="philosophy-title">Our Philosophy</h2>
          <div className="philosophy-content">
            <p className="philosophy-paragraph">
              At ArcaCapitalis, we believe business success should be built, not chased.
            </p>
            <p className="philosophy-paragraph">
              Most business failures occur not because of lack of effort, but because of skipped 
              steps—expansion without foundation, scaling without structure, and growth without planning. 
              We reject that approach.
            </p>
            <p className="philosophy-paragraph">
              Our philosophy is grounded in Economic Masonry: the principle that sustainable businesses must be 
              constructed layer by layer, with each level reinforced before moving upward. Foundation 
              precedes expansion. Structure precedes scale. Planning precedes execution.
            </p>
            <p className="philosophy-paragraph">
              We operate with a long-term mindset, prioritizing durability over speed, systems over 
              hype, and sustainability over short-term gains. If a strategy cannot withstand pressure, 
              challenges, or time, it is not considered viable.
            </p>
            <p className="philosophy-paragraph">
              ArcaCapitalis is committed to helping build businesses that endure—through market cycles, 
              operational challenges, and real-world conditions.
            </p>
          </div>
        </div>
      </section>

      <section className="info-section">
        <div className="info-container">
          <div className="info-card">
            <h3 className="info-title">Strategic Research</h3>
            <p className="info-text">
              Comprehensive research and analysis services designed to support 
              informed business decision-making and strategic planning initiatives.
            </p>
          </div>
          
          <div className="info-card">
            <h3 className="info-title">Operational Structuring</h3>
            <p className="info-text">
              Professional guidance on organizational structure, business frameworks, 
              and documentation to support operational efficiency and scalability.
            </p>
          </div>
          
          <div className="info-card">
            <h3 className="info-title">Business Consulting</h3>
            <p className="info-text">
              Expert consulting services focused on operational efficiency, process 
              improvement, and strategic business development.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;